<template>
	<div class="card card-body border-0 wrapper-box p-0 text-center mb-4 supplier-card position-relative">
		<div class="supplier-img-wrapper">
			<router-link
				v-if="!isLoading && supplierLink"
				class="plain-link"
				:to="supplierLink"
			>
				<div class="supplier-img">
					<img :src="supplierLogo || '/images/ostock-logo-gram.png'" :alt="supplierName">
				</div>
			</router-link>
			<div v-else class="supplier-img">
				<img
					v-if="!isLoading"
					src="/images/ostock-logo-gram.png"
					alt="Supplier Logo"
				>
				<shimmer
					v-else
					width="250px"
					height="180px"
				/>
			</div>
		</div>
		<div class="supplier-detail-container text-left">
			<div class="supplier-name">
				<b v-if="!isLoading">{{ supplierName }}</b>
				<shimmer
					v-else
					height="22px"
					width="140px"
				/>
			</div>
			<div class="supplier-code">
				<small v-if="!isLoading">{{ supplierCode }}</small>
				<shimmer
					v-else
					height="22px"
					width="120px"
				/>
			</div>
			<div class="supplier-origin d-flex align-items-start" v-if="!isLoading">
				<span class="map-icon pr-1"><i class="bi bi-geo-alt-fill"></i></span>
				<span class="label">{{ hasOrigin ? formattedOrigin : '-' }}</span>
			</div>
			<div v-else class="origin-placeholder">
				<shimmer
					height="14px"
					width="140px"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Shimmer from '@/components/Shimmer.vue';

export default {
	name: 'SupplierCard',
	components: {
		Shimmer,
	},
	props: {
		supplier: {
			type: Object,
			default: () => ({}),
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		supplierCode() {
			return this.supplier && this.supplier.code ? this.supplier.code : '';
		},
		formattedOrigin() {
			const origin = this.getOrigin();
			const parts = [];
			if (origin.city && origin.city.name) {
				parts.push(origin.city.name);
			}
			if (origin.province && origin.province.name) {
				parts.push(origin.province.name);
			}
			return parts.join(', ');
		},
		hasOrigin() {
			return this.formattedOrigin.length > 0;
		},
		storeAvailability() {
			const store = this.supplier && this.supplier.store ? this.supplier.store : {};
			if (typeof store.availability === 'boolean') {
				return store.availability;
			}
			return true;
		},
		supplierLink() {
			return this.supplierCode ? `/supplier/${this.supplierCode}` : '';
		},
		supplierName() {
			const supplierName = this?.supplier?.name || '';
			return this.supplier && this.supplier.store && this.supplier.store.name ? this.supplier.store.name : supplierName;
		},
		supplierLogo() {
			return this.supplier && this.supplier.store && this.supplier.store.logo
				? this.supplier.store.logo
				: '';
		},
	},
	methods: {
		getOrigin() {
			const store = this.supplier && this.supplier.store ? this.supplier.store : {};
			const shipping = store.shipping || {};
			return shipping.origin || {};
		},
	},
};
</script>

<style scoped>
.supplier-card {
	border-radius: 5px;
	overflow: hidden;
	min-height: 280px;
}

.supplier-img-wrapper {
	position: relative;
}

.supplier-img {
	position: relative;
	height: 180px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f8f8f8;
	padding: 25px;
}

.supplier-img img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.supplier-detail-container {
	padding: 16px;
}

.supplier-code {
	font-size: 18px;
	font-weight: 700;
	color: #4d4d4d;
	min-height: 28px;
}

.supplier-availability {
	color: #f28900;
	font-size: 12px;
	margin-top: 8px;
}

.supplier-origin {
	margin-top: 12px;
	font-size: 12px;
	color: #616672;
}

.supplier-origin .map-icon {
	color: #d66956;
}

.origin-placeholder {
	margin-top: 12px;
}

.plain-link {
	text-decoration: none !important;
}

@media (max-width: 767px) {
	.supplier-card {
		min-height: 280px;
	}

	.supplier-img {
		height: 160px;
	}

	.supplier-code {
		font-size: 16px;
	}
}
</style>
